module.exports = __webpack_public_path__ + "static/media/group-2.9e80ab63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group-2.png
// module id = 1271
// module chunks = 1